<template src="./byline.html"></template>

<script lang="ts">
import Badge from 'objects/badge/Badge.vue'
import formatName from 'filters/format-name'
import { hostsConfig, turnToConfig } from 'init/config'
import logger from 'util/logger'
import Menu from 'objects/menu/Menu.vue'
import MenuList from 'objects/menu/MenuList.vue'


// from TranslinkService.
// TODO: still using same TransLinkController/service
const VALID_UGC_TYPES = [
  'sq', // question
  'sa', // answer
  'sr', // reply
  'sc' // comment
]
export default {
  data() { return { hasMenuItems: false } },
  props: {
    item: { type: Object },
    menuItems: { type: Array },
    ugcType: {
      type: String,
      validator: (value: string) => VALID_UGC_TYPES.indexOf(value) > -1
    }
  },
  emits: ['menuItemSelected'],
  components: {
    'tt-badge': Badge,
    'tt-menu': Menu,
    'tt-menu-list': MenuList
  },
  computed: {
    purchasedText() {
      if (!this.item.purchaseDateMillis) {
        return null
      }
      return this.$msg('byline.purchased', [this.item.purchaseDateFormatted])
    },
    purchasedDatetime() {
      return (new Date(this.item.purchaseDateMillis)).toISOString()
    },
    // TODO: Make syndication link it's own component?  Trick is how it fits into message,
    // it needs to be a string.  We could just "hope" translations can be done for all
    // languages where the syndication link comes last.  Another possibility is to put
    // the full message inside the anchor tag.
    // TODO: are we still going to be using TransLinkController, etc.?
    syndicationText() {
      if (this.item.syndicationSourceSiteId) {
        const siteName = this.item.syndicationSourceSiteName
        const url = `${hostsConfig.protocol}://${hostsConfig.originHost}/transLink/13/` +
          `${this.ugcType}/${this.item.id}/${turnToConfig.locale}?` +
          `siteId=${this.item.syndicationSourceSiteId}`
        const anchor = `<a target="_blank" href="${url}" rel="nofollow">${siteName}</a>`
        return this.$msg('byline.originallyPosted', [anchor])
      }
      return ''
    }
  },
  methods: {
    formatUserName(user) {
      return formatName(user)
    },
    menuItemSelected(menuItem) {
      this.$emit('menuItemSelected', menuItem)
    },
    selectedAuthor() {
      // TODO...
      logger.debug('author selected...')
    }
  }
}
</script>

<style lang="scss" src="./byline.scss"></style>
